import React from "react";

/**
 * Donut Wheel glyph — the deck's "Add to Wheel" icon (capture round-7 notes7):
 * two concentric rings (r 9.25 / r 5 in a 24 viewBox, stroke 1.7) cut by 5 short
 * radial gap strokes at the brand's unequal Segment angles (spans 78/56/88/52/86°).
 * Butt caps so the cuts meet both rings cleanly. Decorative — callers supply the
 * accessible label on the surrounding control.
 */
const SPANS = [78, 56, 88, 52, 86]; // brand's 5 unequal Segment spans (sum 360)
const CX = 12;
const CY = 12;
const R_OUTER = 9.25;
const R_INNER = 5;

const gapStrokes = () => {
  const cuts = [];
  let acc = -90; // start at 12 o'clock
  SPANS.forEach((span) => {
    const rad = (acc * Math.PI) / 180;
    const x1 = CX + R_INNER * Math.cos(rad);
    const y1 = CY + R_INNER * Math.sin(rad);
    const x2 = CX + R_OUTER * Math.cos(rad);
    const y2 = CY + R_OUTER * Math.sin(rad);
    cuts.push({ x1, y1, x2, y2 });
    acc += span;
  });
  return cuts;
};

const DonutWheelIcon = ({ size = 20, color = "currentColor" }) => (
  <svg
    data-testid="donut-wheel-icon"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.7}
    strokeLinecap="butt"
    aria-hidden="true"
    focusable="false"
    /* width/height ATTRIBUTES lose to any same-specificity-losing author
       stylesheet rule on `svg` (e.g. web-stg's global `svg { width: 100% }`
       reset) -- an inline style wins the cascade regardless, so the icon
       can't be stretched by an ancestor/global reset. */
    style={{ width: size, height: size, flexShrink: 0 }}
  >
    <circle cx={CX} cy={CY} r={R_OUTER} />
    <circle cx={CX} cy={CY} r={R_INNER} />
    {gapStrokes().map((c, i) => (
      <line key={i} x1={c.x1} y1={c.y1} x2={c.x2} y2={c.y2} />
    ))}
  </svg>
);

export default DonutWheelIcon;
